import api from '../../services/api';

export const externalIntegrationsApi = {
  getExternalIntegrations: async (params) => {
    const response = await api.get('admins/get_external_integrations/', { params });
    return response.data;
  },
  
  /**
   * Every external service configured in the platform, with the operator that
   * owns each one. Staff only; anybody else gets a 403.
   */
  getStaffExternalIntegrations: async (params) => {
    const response = await api.get('admins/staff/external-integrations/', { params });
    return response.data;
  },

  /**
   * @param {object} data
   * @param {number|string} [adminId] - Whose integration this is. Only staff
   *   may name somebody else; for anyone else the backend ignores it.
   */
  createExternalIntegration: async (data, adminId) => {
    const response = await api.post('admins/create_external_integration/', {
      external_integration: data,
      ...(adminId ? { admin_id: adminId } : {}),
    });
    return response.data;
  },

  updateExternalIntegration: async (id, data) => {
    const response = await api.patch(`admins/update_external_integration/${id}/`, {
      external_integration: data
    });
    return response.data;
  },

  deleteExternalIntegration: async (id) => {
    const response = await api.delete(`admins/delete_external_integration/${id}/`);
    return response.data;
  },

  getSellersList: async () => {
    const response = await api.get('admins/sellers-list/');
    return response.data;
  }
};
